import { action, makeObservable, observable } from 'mobx';

class LoadingStore {
  @observable loading = false;
  @observable counter = 0;

  constructor() {
    makeObservable(this);
  }

  @action
  open = () => {
    this.counter++;
    this.loading = true;
  };

  @action
  close = () => {
    this.counter--;

    if (this.counter <= 0) {
      this.loading = false;
    }
  };
}

export default new LoadingStore();
